module.exports = __webpack_public_path__ + "2e96cbc72510f1b9f4722dcd72501d4c.svg";